import routes from './constants';
import instanceQuestion from './instanceQuestion';

export const fetchQuestion = async (timeline_id: string | null) => {
  const response = await instanceQuestion.get(`${routes.API_GET_QUESTION}?timeline_id=${timeline_id}`);
  return response.data;
};